import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router';

import LINK from 'constants/link.const';

import CustomAuthLayout from './components/CustomAuth/CustomAuthLayout';
import ManagerLayout from './components/Manager/ManagerLayout';
import OrderReceivedLayout from './components/OrderReceived/OrderReceived';

import 'styles/stocks/layout.scss';

// eslint-disable-next-line react/prefer-stateless-function
class PageContent extends React.Component {
  render() {
    return (
      <section
        className={`page-content stocks ${
          // eslint-disable-next-line no-nested-ternary
          this.props.currentSalon.calendar_mode === 'light' ? 'light-class' : this.props.currentSalon.calendar_mode === 'dark' ? 'dark-class' : 'bright-class'
        }`}
      >
        <Switch>
          <Route exact path={LINK.stocksManager} component={ManagerLayout} />
          <Route exact path={LINK.stocksUsedSold} component={ManagerLayout} />
          <Route exact path={LINK.stocksHolding} component={ManagerLayout} />
          <Route exact path={LINK.stocksMovement} component={ManagerLayout} />

          <Route path="/salon/:id/stocks/customauth" component={CustomAuthLayout} />
          <Route path="/salon/:id/stocks/orderReceived" component={OrderReceivedLayout} />
        </Switch>
      </section>
    );
  }
}

function mapStateToProps(state) {
  const { currentSalon } = state;

  return {
    currentSalon,
  };
}

export default connect(mapStateToProps)(PageContent);
